export default __webpack_public_path__ + "static/media/kunle.9eecc124.jpg";